import React from 'react';

import { CogIcon } from '@heroicons/react/outline';

import EmptyState from 'components/EmptyState';

const SweetheartListPageBeingGenerated = () => (
  <EmptyState
    helmetTitle="Sweetheart List"
    testId="sweetheartList-ListBeingGenerated"
    title="We're currently generating your Sweetheart list!"
    subtitle="We'll notify you via email once your list is ready to view."
    Icon={CogIcon}
  />
);

export default SweetheartListPageBeingGenerated;
